<template>
  <div class="select-staff--container shadow-card no-select">
    <div class="select-staff--title">Выбрать сотрудника:</div>
    <div class="select-staff--list">
      <ul class="select-staff--ul cursor-pointer">
        <li
          @click="selectStaff(item.id)"
          class="select-staff--li"
          v-for="item in staff"
          :key="item.id"
        >
          <div
            class="select-line"
            v-bind:class="{ active: item.active === true }"
          ></div>
          <div class="avatar">
            <img :src="item.avatar" />
          </div>
          <div class="data">
            <div class="name">{{ item.name }}</div>
            <div class="profession">{{item.profession}}</div>
            <div class="schedule">
              ({{
                item.nearest
              }})
            </div>
          </div>
          <div class="checked">
            <div v-if="!item.active" class="check_circle_false_orange"></div>
            <div v-if="item.active" class="check_circle_true_orange"></div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import staffRepository from "../../../../repositories/staff";

export default {
  name: "SelectStaff",
  components: {},
  data() {
    return {
      staff: []
    };
  },
  props: {
    services: Array, // Список выбранных услуг
    selectReset: Number, // Сброс данных компонента
    componentReset: Number,
    rerender: Boolean
  },
  watch: {
    rerender: function(val) {
      if (val === true && !this.staff.length) {
        this.createdComponent();
      }
    },
    componentReset: function() {
      this.resetComponent();
    },
    selectReset: function() {
      this.resetSelect();
    }
  },
  computed: {},
  methods: {
    getServicesIds() {
      let result = {
        services: [],
        modifications: []
      };
      for (let key in this.services) {
        if(+this.services[key].modification_id === 0){
          result.services[result.services.length] = this.services[key].service_id;
        }else{
          result.modifications[result.modifications.length] = this.services[key].modification_id;
        }
      }
      return result;
    },
    // Добавляет необходимые для рендерига параметры в полученных от сервера данных
    filteredGetData(data) {
      let result = data;
      for (let key in result) {
        result[key].active = false;
      }
      return result;
    },
    selectStaff(staff) {
      for (let key in this.staff) {
        if (+this.staff[key].id === +staff) {
          this.staff[key].active = true;
        } else {
          this.staff[key].active = false;
        }
      }
      this.emitStaff();
    },
    emitStaff() {
      let result = null;
      for (let key in this.staff) {
        if (this.staff[key].active === true) {
          result = this.staff[key];
        }
      }
      this.$emit("selectStaff", result);
    },
    emitStaffAndNext(){
      let result = null;
      for (let key in this.staff) {
        if (this.staff[key].active === true) {
          result = this.staff[key];
        }
      }
      this.$emit("selectAndNext", result);
    },
    resetSelect() {
      for (let key in this.staff) {
        this.staff[key].active = false;
      }
      this.emitStaff();
    },
    resetComponent() {
      this.staff = [];
      this.emitStaff();
    },
    checkForOneStaff(){
      if(this.staff.length === 1){
        this.selectStaff(this.staff[0].id);
        this.emitStaffAndNext();
      }
    },
    createdComponent() {
      this.$store.dispatch("startPreloader");

      staffRepository.getStaffByServices({list: JSON.stringify(this.getServicesIds())}).then(resp => {
        this.staff = this.filteredGetData(resp.data);
        this.checkForOneStaff();
        this.$store.dispatch("stopPreloader");
      }).catch(err => {
        this.$store.dispatch("addNotification", {
          text: err.response.data.message,
          time: 6,
          color: "danger"
        });
        this.$store.dispatch("stopPreloader");
      });

    }
  },
  created() {
    // this.createdComponent();
  }
};
</script>

<style scoped lang="less">
.select-staff--ul {
  margin: 0;
  padding: 0;
}
.select-staff--li {
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-between;
  flex-direction: row;
  list-style-type: none;
  border-bottom: 1px solid #e2e7ed;
  /*padding: 3px 0;*/

  .select-line {
    width: 2px;
  }
  .select-line.active {
    background-color: #f97979;
  }
  .avatar {
    width: 20%;
    text-align: center;
    padding: 3px 0;
    position: relative;

    img {
      width: 50px;
      position: absolute;
      margin: auto;
      left: 0;
      top: 0;
      bottom: 0;
      right: 0;
    }
  }
  .data {
    width: 60%;
    padding: 4px;
    color: #4f4f4f;

    .name {
      font-size: 16px;
    }
    .profession{
      color: gray;
      font-size: 13px;
      margin-top: 4px;
    }
    .schedule {
      margin-top: 5px;
      font-size: 12px;
    }
  }
  .checked {
    text-align: center;
    width: 20%;
    line-height: 53px;
    position: relative;

    .check_circle_false_orange, .check_circle_true_orange{
      position: absolute;
      margin: auto;
      left: 0;
      top: 0;
      bottom: 0;
      right: 0;
    }
  }
}
.select-staff--li:hover {
  background-color: #f5f5f6;
}
.select-staff--title {
  text-align: center;
  color: #4f4f4f;
  font-size: 16px;
  margin-bottom: 30px;
}
</style>
